import { render, staticRenderFns } from "./BoXueJia.vue?vue&type=template&id=069e9e06&scoped=true&"
import script from "./BoXueJia.vue?vue&type=script&lang=js&"
export * from "./BoXueJia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e9e06",
  null
  
)

export default component.exports